(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/shared-components/main-page.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/shared-components/main-page.js');

'use strict';

const {
  FooterText,
  HeaderText,
  LoginIframe,
  LoginPaper,
  ScamWarning,
  SvsLogo
} = svs.playerLoginReact.sharedComponents;
const {
  ProductCylinderWrapper
} = svs.tb_ui_react.cylinder_wrapper;
const {
  allowedGames
} = svs.playerLoginReact.constants;
const useStatusBarColor = svs.components.tb_ui_react.useStatusBarColor.useStatusBarColor;
const isLogin = false;
const defultSelectedGames = [allowedGames.EUROJACKPOT, allowedGames.TRISS, allowedGames.LOTTO];

const MainPage = _ref => {
  let {
    children
  } = _ref;
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);
  const branding = ReactRedux.useSelector(state => state.playerloginreact.theme.branding);
  const fontColor = ReactRedux.useSelector(state => state.playerloginreact.theme.fontColor);
  const brandingArray = branding ? Array(3).fill(branding) : defultSelectedGames;
  useStatusBarColor('player-login-react-view');
  return React.createElement(React.Fragment, null, React.createElement(ProductCylinderWrapper, {
    isDefault: !branding,
    products: brandingArray
  }), React.createElement("div", {
    className: "u-position-relative"
  }, React.createElement("div", {
    className: "".concat(fontColor, " align-center f-body line-height-150 u-flex u-flex-column login-react-main-page padding-1 login-react-max-width-500")
  }, React.createElement(HeaderText, {
    isBankId: true,
    isLogin: isLogin
  }), isStandardMobile && React.createElement("div", {
    className: "u-flex-grow-1"
  }, React.createElement(SvsLogo, null)), React.createElement("div", {
    className: "padding-bottom-1".concat(!isStandardMobile ? ' u-flex-grow-1' : '')
  }, svs.core.detect.feature('ft-iam-iframe') ? React.createElement(LoginIframe, null) : React.createElement(LoginPaper, null, children), React.createElement(FooterText, {
    isBankId: true,
    isLogin: isLogin
  }), React.createElement(ScamWarning, null)), !isStandardMobile && React.createElement("div", {
    className: "margin-bottom-2"
  }, React.createElement(SvsLogo, null)))));
};
svs.playerLoginReact.sharedComponents.MainPage = MainPage;

 })(window);